import type { YearBuiltQuoteFormInput } from 'app/home/create-quote/forms/property-details/year-built/year-built.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function yearBuiltQuoteFormSelector(store: QuoteDraftSelectorState): YearBuiltQuoteFormInput {
  const yearBuilt = store.yearBuilt();
  const sqFt = store.sqFt();
  const stories = store.stories();
  const pool = store.pool();

  return {
    yearBuilt,
    sqFt,
    stories,
    pool,
  };
}

export function yearBuiltQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['year-built']();
}
